<div class="container display-flex">
  <div class="headerline display-flex display-layout-row justify-content-space-between align-items-center">
    <div class="display-layout-row">
      <div class="logo-container">
        <img src="../../assets/images/logo_transparent.png" class="logo" />
      </div>
      <div class="display-layout-row" class="logo_header">
        <div>vr-cargo | airline-broker</div>
      </div>
    </div>
    <div class="display-layout-row layout-align-center-center layout-gap-5">
      <div class="display-layout-row layout-gap-10">
        <div class="version">v0.9.8</div>
          <div class="version">Logged in as <strong>{{ username }}</strong>    </div>

      </div>
      <button class="version" (click)="logout()" mat-icon-button matTooltip="Logout">
        <mat-icon class="logout">login</mat-icon>
      </button>
    </div>
  </div>
</div>
